import { CONTINUOUS_EDUCATION } from '../../api/endpoints';
import request from '../../api/request';
import { CreateSectionBody } from '../../types/sectionMaintainerTypes';

export const createNonStructuredSectionRequest = (data: CreateSectionBody) => {
  return request(CONTINUOUS_EDUCATION.SECTIONS, {
    method: 'POST',
    data,
  });
};

// Placeholder for now, moving forward with basic structure first
export const getNonStructuredSections = async () => {
  return { data: [] };
};
